import React from "react";
// import Particles from "react-tsparticles";
// import { loadFull } from "tsparticles";
// import helper from './helper'

export default function ParticleComponent(){
    return <div id='tsparticles' style={{position:'fixed',height:'100vh',width:'100vw'}}> 
    </div>
};
  